import React, { useState, useEffect, useCallback } from "react";
import { BlurBox } from "./SpheresStyled";
import { ScalingContainer } from "../../AppStyled";
import Header from "./header/Header";
import Main from "./main/Main";
import Text from "./text/Text";
import Footer from "./footer/Footer";
import SetBet from "./setBet/SetBet";

import AutoPage from "../otherPages/auto/AutoPage";
import Settings from "../otherPages/settings/Settings";
import ProvFair from "../otherPages/provFair/ProvFair";
import History from "../otherPages/history/History";
import GameRules from "../otherPages/gameRules/GameRules";
import BetReplay from "../otherPages/betReplay/BetReplay";
import Guide from "../otherPages/betReplay/Guide";

import useSound from "use-sound";

import fastBackgroundSound from "../../audio/fastBackground.mp3";
import slowBackgroundSound from "../../audio/slowBackground.mp3";
import useLoading from "../loading/useLoading";
import Loading from "../loading/Loading";
import { logger } from "../../lib/logger";

export default function Spheres({
  bet,
  betInfo,
  isFast,
  handleIsFast,
  isAutoOn,
  isClickable,
  handleIsClickable,
  userSettings,
  saveUserSettings,
  toggleIsAutoOn,
  Globals,
  history,
  saveBetAndPlay,
  handleAutoRollLogic,
  autoConfigs,
  handleBetAmount,
  provablyFair,
  notifyMSG, // todo
  handleNotification, // todo
  autorollLogic,
  showText,
  handleShowText,
  toFix,
  currency,
  minBet,
  maxBet,
  handleVerifyBet,
  betReplay,
  handleBetReply,
  user_id,
}) {
  const [above, setabove] = useState(false);
  // const [above, setabove] = useState("betReply");
  const [scrollable, setscrollable] = useState(false);
  const [lastWidth, setlastWidth] = useState(window.innerWidth);
  const [lastHeight, setlastHeight] = useState(window.innerHeight);
  const [showHistory, setshowHistory] = useState(false);
  const [showGameRules, setshowGameRules] = useState(false);

  const { volume, music } = userSettings;
  const [fastBackgroundSfx, fastObj] = useSound(fastBackgroundSound, {
    volume,
  });
  const [slowBackgroundSfx, slowObj] = useSound(slowBackgroundSound, {
    volume,
  });


  useEffect(() => {
    if (above === "gameRules") {
      setTimeout(() => {
        setshowGameRules(true);
      }, 100);
    } else {
      setshowGameRules(false);
    }
    if (above === "history") {
      setTimeout(() => {
        setshowHistory(true);
      }, 100);
    } else {
      setshowHistory(false);
    }
  }, [above]);
  const [unBlur, setunBlur] = useState(false);
  // const handleAbove = (e) => setabove(e);
  const handleAbove = (a) => {
    handleNotification(false);
    if (!a) {
      setunBlur(true);
      setTimeout(() => {
        setunBlur(false);
        setabove(a);
      }, 400);
    } else {
      setabove(a);
    }
  };
  const [intViewportHeight, setintViewportHeight] = useState(
    window.innerHeight,
  );

  const handleResize = useCallback(
    (a) => {
      setscrollable(false);
      if (window.innerHeight < 667) {
        if (
          !(
            window.innerWidth === lastWidth && window.innerHeight === lastHeight
          )
        ) {
          if (
            window.innerWidth === lastWidth &&
            window.innerHeight < lastHeight - 100
          ) {
            setscrollable(true);
          } else {
            setlastHeight(window.innerHeight);
            setlastWidth(window.innerWidth);
            setintViewportHeight(window.innerHeight);
          }
        }
      }
    },
    [lastWidth, lastHeight],
  );

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener('resize', handleResize)
  }, [handleResize]);

  const toggleIsItInput = (e) => logger.log(e);

  const enableLoading = false
  const [isLoaded, setisLoaded] = useState(false)
  const pages = [
    "settings",
    "gameRules",
    // "provFair",
    "history",
    "guide",
    'auto'
  ]
  const loadedPages = enableLoading ? [] : pages

  const [arePagesLoaded, duration] = useLoading(handleAbove, loadedPages)
  useEffect(() => {
    setisLoaded(arePagesLoaded)
  }, [arePagesLoaded, user_id, setisLoaded])

  useEffect(() => {
    if (isLoaded) {
      if (isFast) {
        music
          ? (() => {
            if (!fastObj.isPlaying) fastBackgroundSfx();
          })()
          : fastObj.stop();
        slowObj.stop();
        return;
      } else {
        music
          ? (() => {
            if (!slowObj.isPlaying) slowBackgroundSfx();
          })()
          : slowObj.stop();
        fastObj.stop();
        return;
      }
    }
  }, [isFast, music, fastBackgroundSfx, fastObj, slowBackgroundSfx, slowObj, isLoaded]);


  return (
    <>
      {isLoaded ? <div>
        <ScalingContainer className="ScalingContainer" h={intViewportHeight}>
          <BlurBox
            className="blurbox"
            blur={above}
            unBlur={unBlur}
            onContextMenu={(e) => e.preventDefault()}
          // fadeInKeno={fadeInKeno}
          // showLoading={showLoading}
          // blur={above && above !== "history"}
          >
            <Header
              betInfo={betInfo}
              currency={currency}
              handleAbove={handleAbove}
              toFix={toFix}
              isFast={isFast}
              userSettings={userSettings}
            />
            <Main
              isFast={isFast}
              betInfo={betInfo}
              isAutoOn={isAutoOn}
              handleIsClickable={handleIsClickable}
              handleShowText={handleShowText}
              userSettings={userSettings}
            />
            <Text
              betInfo={betInfo}
              isFast={isFast}
              isAutoOn={isAutoOn}
              showText={showText}
              toFix={toFix}
              userSettings={userSettings}
              currency={currency}
            />
            <Footer
              className="footer"
              bet={bet}
              betInfo={betInfo}
              clickable={isClickable}
              isAutoOn={isAutoOn}
              isFast={isFast}
              handleIsFast={handleIsFast}
              toggleIsAutoOn={toggleIsAutoOn}
              handleBetAmount={handleBetAmount}
              handleNotification={handleNotification}
              userSettings={userSettings}
              saveBetAndPlay={saveBetAndPlay}
              handleAbove={handleAbove}
              betCount={autorollLogic.numBets}
              betTotal={autoConfigs.numberOfBets}
              currency={currency}
              toFix={toFix}
              minBet={minBet}
              maxBet={maxBet}
            />
          </BlurBox>
        </ScalingContainer>
        {(above === "settings" ||
          above === "history" ||
          above === "provFair" ||
          above === "gameRules") && (
            <Settings
              handleAbove={handleAbove}
              unBlur={unBlur}
              scaleDown={
                above === "history" || above === "provFair" || above === "gameRules"
              }
              isClickable={isClickable}
              userSettings={userSettings}
              saveUserSettings={saveUserSettings}
              h={intViewportHeight}
            />
          )}
        {above === "auto" && (
          <AutoPage
            bet={bet}
            betInfo={betInfo}
            unBlur={unBlur}
            autoConfigs={autoConfigs}
            userSettings={userSettings}
            handleAutoRollLogic={handleAutoRollLogic}
            handleNotification={handleNotification}
            handleAbove={handleAbove}
            toFix={toFix}
            maxBet={maxBet}
            minBet={minBet}
            onfocus={toggleIsItInput}
            h={intViewportHeight}
            scrollable={scrollable}
            currency={currency}
            opacity
          />
        )}
        {above === "provFair" && (
          <ProvFair
            pf={provablyFair}
            unBlur={unBlur}
            Globals={Globals}
            notifyMSG={notifyMSG}
            handleNotification={handleNotification}
            handleAbove={handleAbove}
            h={intViewportHeight}
            overflow
            isClickable={isClickable}
            isAutoOn={isAutoOn}
            scrollable={scrollable}
            userSettings={userSettings}
          />
        )}
        {showHistory && (
          <History
            history={history}
            handleAbove={handleAbove}
            toFix={toFix}
            h={intViewportHeight}
            userSettings={userSettings}
            handleVerifyBet={handleVerifyBet}
            user_id={user_id}
            handleNotification={handleNotification}
          />
        )}

        {above && above.startsWith("setBet") && (
          <SetBet
            bet={above.substr(6, above.length)}
            unBlur={unBlur}
            // betInfo={betInfo}
            userSettings={userSettings}
            handleBetAmount={handleBetAmount}
            handleAbove={handleAbove}
            handleNotification={handleNotification}
            toFix={toFix}
            currency={currency}
            minBet={minBet}
            maxBet={maxBet}
            h={intViewportHeight}
            scrollable={scrollable}
            prec={toFix}
          />
        )}

        {showGameRules && (
          <GameRules
            unBlur={unBlur}
            handleAbove={handleAbove}
            h={intViewportHeight}
            userSettings={userSettings}
          />
        )}
        {above === "betReply" && (
          <BetReplay
            // history={history}
            handleAbove={handleAbove}
            toFix={toFix}
            h={intViewportHeight}
            userSettings={userSettings}
            betReplay={betReplay}
            handleBetReply={handleBetReply}
            handleNotification={handleNotification}
          />
        )}
        {above === "guide" && (
          <Guide
            // history={history}
            handleAbove={handleAbove}
            toFix={toFix}
            h={intViewportHeight}
            userSettings={userSettings}
          />
        )}
      </div> : <Loading duration={duration} />}
    </>
  );
}
